var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBaggageIcon = function SvgBaggageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.428,
    height: 11.836,
    viewBox: "0 0 8.428 11.836",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1046",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1046",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8335",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8335",
    d: "M1.2,0h6.02a1.2,1.2,0,0,1,1.2,1.2V7.826a1.2,1.2,0,0,1-1.2,1.2H1.2A1.2,1.2,0,0,1,0,7.826V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(0 1.355)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_124",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 124",
    y2: 1.806,
    transform: "translate(2.709 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_125",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 125",
    y2: 1.806,
    transform: "translate(5.719 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_126",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 126",
    x2: 3.913,
    transform: "translate(2.258 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_127",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 127",
    y1: 1.204,
    transform: "translate(1.806 9.632)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_128",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 128",
    y1: 1.204,
    transform: "translate(6.622 9.632)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBaggageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/baggageIcon.75998616.svg";
export { ForwardRef as ReactComponent };